import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/Isabella_Renters/subs.vtt';
import poster from '@/static/assets/reviews/Isabella_Renters/video.jpg';

export const Isabella: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Renters, ReviewProduct.All],
  reviewerName: 'Isabella',
  videoUrl: `${ASSETS_URL}/renters/Isabella_Renters.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
